module.exports = __webpack_public_path__ + "static/clickup-e489105624edbff889081b71ac598c7c.png";